module.exports = __webpack_public_path__ + "img/banner_03.46b4ca2.png";